import { QueryVariables } from '../../types';

export const INSTAGRAM_SEARCH_PARAMS = {
  BEFORE: 'before',
  AFTER: 'after',
  LIMIT: 'limit',
  QUERY: 'query',
  AGE_BUCKETS: 'ageBuckets',
  GENDERS: 'genders',
  COUNTRIES: 'countries',
  INTERESTS: 'interests',
  MIN_FOLLOWERS: 'minFollowers',
  MAX_FOLLOWERS: 'maxFollowers',
  MIN_ENGAGEMENTS: 'minEngagements',
  MAX_ENGAGEMENTS: 'maxEngagements',
  MAJOR_AUDIENCE_AGE_BUCKETS: 'majorAudienceAgeBuckets',
  MAJOR_AUDIENCE_GENDERS: 'majorAudienceGenders',
  MAJOR_AUDIENCE_COUNTRIES: 'majorAudienceCountries',
  SIMILAR_TO_CREATORS: 'similarToCreators',
  REQUIRE_IN_CREATOR_MARKETPLACE: 'requireInCreatorMarketplace',
} as const satisfies Record<string, keyof QueryVariables>;
